const InResiLogo = () => (
  <svg
    width="80"
    height="31"
    viewBox="0 0 80 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8834_30531)">
      <path
        d="M66.4163 22.7045C63.9552 21.8559 62.3576 19.6304 62.3922 17.1193H65.5873C65.7341 18.0198 66.0364 18.7818 66.7272 19.3014C67.5735 19.9422 68.722 20.0634 69.7065 19.7084C70.2592 19.5092 70.5873 19.0589 70.6219 18.548C70.6996 17.2578 69.3524 16.9201 68.2816 16.5824C66.589 16.0542 64.4906 15.5346 63.4802 13.898C62.0726 11.612 62.9707 8.65055 65.3628 7.4296C68.5061 5.82765 73.1348 6.8148 74.2315 10.5989L70.76 11.7679C70.501 11.0492 70.0778 10.443 69.5597 10.1573C68.817 9.74161 68.0053 9.75027 67.3144 10.1053C66.6236 10.4603 66.6149 10.7894 66.5977 11.2483C66.5804 11.7073 66.8567 12.1575 67.2972 12.4346C68.6616 13.2919 70.5355 13.4131 72.2885 14.2617C73.8343 15.0064 74.6806 16.4352 74.646 18.1411C74.6115 20.0114 73.6443 21.648 71.8999 22.4274C70.1987 23.1807 68.2384 23.3279 66.4163 22.6958V22.7045Z"
        fill="#181232"
      />
      <path
        d="M36.5117 7.13522H40.32V9.51651H40.4323C41.2008 8.02712 42.6689 6.6936 44.7587 6.6936C46.8485 6.6936 46.244 6.7369 46.244 6.9707V11.309C45.6136 11.0838 44.8364 11.0059 44.3701 11.0059C40.7863 11.0059 40.3718 14.3484 40.3718 16.5911V22.5659H36.5117V7.13522Z"
        fill="#181232"
      />
      <path
        d="M0.44043 24.4277H2.35753C2.91884 24.4277 4.10192 24.6874 4.10192 26.021C4.10192 27.3545 2.90157 27.6749 2.40071 27.6749H1.26081V29.5453H0.44043V24.419V24.4277ZM2.21936 26.8782C2.69432 26.8782 3.23836 26.6964 3.23836 26.0296C3.23836 25.3629 2.69432 25.1897 2.21936 25.1897H1.26945V26.8782H2.22799H2.21936Z"
        fill="#181232"
      />
      <path
        d="M4.42188 27.7355C4.42188 26.6011 5.19044 25.7958 6.28716 25.7958C7.38388 25.7958 8.15245 26.6011 8.15245 27.7355C8.15245 28.8699 7.39251 29.6665 6.28716 29.6665C5.18181 29.6665 4.42188 28.8699 4.42188 27.7355ZM7.3407 27.7355C7.3407 27.0341 6.90892 26.5319 6.28716 26.5319C5.6654 26.5319 5.23362 27.0341 5.23362 27.7355C5.23362 28.4369 5.6654 28.9305 6.28716 28.9305C6.90892 28.9305 7.3407 28.4282 7.3407 27.7355Z"
        fill="#181232"
      />
      <path
        d="M8.41992 25.8997H9.30075L10.1384 28.5408H10.1557L11.0451 25.8997H11.7446L12.6341 28.5408H12.6514C12.9363 27.6575 13.2213 26.783 13.4976 25.8997H14.3785L13.1436 29.5539H12.2196C11.9432 28.7226 11.6669 27.874 11.4078 27.0341C11.1401 27.8654 10.8465 28.7226 10.5615 29.5539H9.66345L8.42856 25.8997H8.41992Z"
        fill="#181232"
      />
      <path
        d="M14.6463 27.7355C14.6463 26.6098 15.3976 25.7872 16.4598 25.7872C17.522 25.7872 18.1869 26.3154 18.1869 27.7009V27.9347H15.4235C15.484 28.5841 15.933 28.9651 16.503 28.9651C17.0729 28.9651 17.3061 28.6967 17.4788 28.2724L18.2042 28.5581C17.9538 29.1989 17.3234 29.6578 16.503 29.6578C15.6826 29.6578 14.6377 28.8958 14.6377 27.7355H14.6463ZM16.4512 26.4626C15.9158 26.4626 15.5617 26.8349 15.4667 27.3718H17.4011C17.3493 26.705 16.9002 26.4626 16.4512 26.4626Z"
        fill="#181232"
      />
      <path
        d="M18.9461 25.8997H19.7061V26.5146H19.732C19.9133 26.1162 20.3019 25.7958 20.8028 25.7958C21.3036 25.7958 21.0359 25.8132 21.1741 25.8651V26.731C21.0359 26.6791 20.846 26.6618 20.7251 26.6618C19.896 26.6618 19.7147 27.4411 19.7147 28.0386V29.5539H18.9375V25.8997H18.9461Z"
        fill="#181232"
      />
      <path
        d="M21.3905 27.7355C21.3905 26.6098 22.1418 25.7872 23.2039 25.7872C24.2661 25.7872 24.9311 26.3154 24.9311 27.7009V27.9347H22.1677C22.2281 28.5841 22.6772 28.9651 23.2471 28.9651C23.8171 28.9651 24.0502 28.6967 24.2229 28.2724L24.9483 28.5581C24.6979 29.1989 24.0675 29.6578 23.2471 29.6578C22.4267 29.6578 21.3818 28.8958 21.3818 27.7355H21.3905ZM23.1953 26.4626C22.6599 26.4626 22.3058 26.8349 22.2109 27.3718H24.1452C24.0934 26.705 23.6444 26.4626 23.1953 26.4626Z"
        fill="#181232"
      />
      <path
        d="M25.458 27.7268C25.458 26.5319 26.2007 25.7958 27.116 25.7958C28.0314 25.7958 28.066 26.0643 28.2991 26.4539H28.3164V24.2978H29.0936V28.4109C29.0936 29.0257 29.1368 29.2682 29.2145 29.5539H28.4373C28.3855 29.3375 28.3596 29.1729 28.3682 29.0084H28.3509C28.0746 29.4587 27.5996 29.6665 27.1247 29.6665C26.1143 29.6665 25.458 28.8525 25.458 27.7268ZM28.325 27.7182C28.325 27.0168 27.8673 26.5319 27.2801 26.5319C26.6929 26.5319 26.2611 27.0341 26.2611 27.7268C26.2611 28.4196 26.6843 28.9218 27.2801 28.9218C27.876 28.9218 28.325 28.4196 28.325 27.7182Z"
        fill="#181232"
      />
      <path
        d="M31.7793 24.4277H33.8346C34.8536 24.4277 35.4149 25.0165 35.4149 25.7525C35.4149 26.4886 35.1472 26.757 34.5686 26.9215V26.9388C35.1817 27.0601 35.5876 27.5017 35.5876 28.1598C35.5876 29.1556 34.6809 29.5539 33.8864 29.5539H31.7793V24.4277ZM33.5928 26.6098C34.0936 26.6098 34.5513 26.402 34.5513 25.9084C34.5513 25.4148 34.0677 25.1897 33.5841 25.1897H32.6083V26.6098H33.5928ZM33.705 28.7919C34.2059 28.7919 34.7068 28.5841 34.7068 28.0732C34.7068 27.5623 34.1973 27.3285 33.6964 27.3285H32.5997V28.7919H33.705Z"
        fill="#181232"
      />
      <path
        d="M37.3233 29.6751L35.8984 25.8997H36.7534C37.0901 26.7916 37.401 27.6835 37.7378 28.636H37.7551C38.0919 27.6749 38.4114 26.783 38.7395 25.8997H39.5686L37.6342 31H36.8224L37.3319 29.6751H37.3233Z"
        fill="#181232"
      />
      <path
        d="M75.2246 2.35531C75.2246 1.0824 76.2436 0 77.6253 0C79.007 0 80.0001 1.0824 80.0001 2.35531C80.0001 3.62821 78.9811 4.81453 77.6253 4.81453C76.2695 4.81453 75.2246 3.73212 75.2246 2.35531ZM75.665 7.1352H79.5251V22.5659H75.665V7.1352Z"
        fill="#181232"
      />
      <path
        d="M0 2.35531C0 1.0824 1.019 0 2.40069 0C3.78238 0 4.77547 1.0824 4.77547 2.35531C4.77547 3.62821 3.75648 4.81453 2.40069 4.81453C1.0449 4.81453 0 3.73212 0 2.35531ZM0.440414 7.1352H4.30052V22.5659H0.440414V7.1352Z"
        fill="#181232"
      />
      <path
        d="M5.49219 7.13522H9.30048V9.40394H9.35229C10.4836 7.55087 12.2452 6.6936 14.1278 6.6936C16.9689 6.6936 19.5077 8.63327 19.5077 12.833V22.5659H15.6476V14.5475C15.6476 12.5039 15.1209 10.3997 12.7547 10.3997C10.3886 10.3997 9.36093 11.6727 9.36093 14.6081V22.5746H5.50082V7.13522H5.49219Z"
        fill="#181232"
      />
      <path
        d="M35.0087 22.5659H21.1572V12.2615L28.083 6.96204L35.0087 12.2615V22.5659Z"
        fill="#B4D6FF"
      />
      <path
        d="M57.6684 17.2924H61.1054C60.6477 19.9335 58.9551 22.1416 56.2781 22.8343C54.7064 23.2413 53.1002 23.1807 51.5545 22.6612C46.8222 21.0765 45.4836 15.5346 47.3489 11.3695C48.627 8.512 51.4508 6.94468 54.5337 7.1525C57.4439 7.35166 59.8101 9.17876 60.665 11.9843C61.0795 13.3525 61.1831 14.7726 61.0968 16.1754H50.2937C50.5096 18.4181 52.4698 19.9508 54.7237 19.6564C56.1486 19.6045 57.323 18.7818 57.6771 17.2838L57.6684 17.2924ZM57.3576 13.5863C57.2453 12.4173 56.8135 11.6207 56.0363 10.9885C54.8446 10.2179 53.2298 10.1313 52.0294 10.9452C51.1313 11.56 50.6477 12.5645 50.4836 13.595H57.3576V13.5863Z"
        fill="#181232"
      />
    </g>
    <defs>
      <clipPath id="clip0_8834_30531">
        <rect width="80" height="31" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

type Props = {
  className?: string;
};

export const PoweredBy = ({ className }: Props) => {
  return (
    <div className={className} style={{ height: "auto" }}>
      <InResiLogo />
    </div>
  );
};
